import type { T } from '@common/hooks/useTranslation';

/**
 * Generates validation rules for the job title field.
 * @param t - The translation function.
 * @returns The validation rules object.
 */
export function jobTypeRules(t: T) {
  return {
    required: t('validations.job.type.required')
  };
}
